<template>
    <form action="" @submit.prevent="formSubmit()" class="newsletter-form">
        <div class="loader-wrap" v-if="loading">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <div v-if="!loading && showForm">
            <div class="form-item">
                <input type="checkbox" :id="monthlyId" :name="monthlyId" class="taaf" v-model="form.taaf">
                <label :for="monthlyId">
                    <slot name="labelMonth"></slot>
                </label>
            </div>
            <!-- <div class="form-item">
                <input type="checkbox" :id="semId" :name="semId" class="taaf" v-model="form.rnn">
                <label :for="semId">
                    <slot name="labelSemestre"></slot>
                </label>
            </div> -->

            <div class="form-item email">
                <span class="icon-arrow-right" @click="formSubmit()"></span>
                <input type="email" :name="emailId" :id="emailId" v-model="form.email" placeholder="Votre e-mail">
            </div>
        </div>
        <div v-if="confirmMessage" class="confirm-message">
            <p v-html="confirmMessage"></p>
        </div>

    </form>
</template>

<script>
    import $ from "jquery";
    import Ajax from "../../mixins/ajax"
    import Swal from "sweetalert2/dist/sweetalert2.js";

    export default {
        props: ['footer'],
        mixins: [Ajax],
        data() {
            return {
                loading: false,
                form: {
                    taaf: false,
                    rnn: false,
                    email: null
                },
                confirmMessage: null,
                showForm:true
            };
        },
        computed: {
            monthlyId() {
                return this.footer ? 'monthly_foot' : 'monthly'
            },
            semId() {
                return this.footer ? 'semestre_foot' : 'semestre'
            },
            emailId() {
                return this.footer ? 'email_foot' : 'email'
            }
        },
        methods: {
            formSubmit() {

                if (!this.form.taaf && !this.form.rnn){
                    Swal.fire({
                        title: "Erreur !",
                        text: "Vous devez sélectionner au moins une liste de diffusion.",
                        type: "error",
                        confirmButtonText: "Compris"
                    });
                    return
                }

                this.loading = true;
                this.showForm = false;

                this.ajaxPost("newsletter", "subscribeNewsletter", {form: this.form}).always((data) => {

                    if (data.StatusCode === 200) {
                        this.loading = false;
                        this.confirmMessage = data.ErrorMessage

                    } else {
                        this.loading = false;
                        this.showForm = true;
                        this.confirmMessage = data.ErrorMessage
                    }
                });


            },
        },
        mounted() {
        },
        destroyed() {
        }
    };
</script>
